export const ApckProgressBar = {
    props: {
        label: String,
        min: {
            type: [Number, String],
            default: 0,
        },
        max: {
            type: [Number, String],
            default: 100,
        },
        percent: {
            type: Number,
            default: 0,
        },
        handler: {
            type: Function,
        },
    },
    computed: {
        styleWidth() {
            return {
                width: `${this.percent}%`,
            };
        },
    },
    template: `
        <div class="metric">
            <span class="label">{{ label }}</span>
            <div class="progress-bar">
                <div class="progress-bar-fill" :style="styleWidth">
                    <span>{{ percent }}%</span>
                </div>
            </div>
            <span class="min-label">{{ min }}</span>
            <span class="max-label">{{ max }}</span>
        </div>
    `,
};
